/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import GroupAudioCallPartipateList from './GroupAudioCallParticipateList';
import CallEndIcon from '@mui/icons-material/CallEnd';
import PhoneIcon from '@mui/icons-material/Phone';
import CallIcon from '@mui/icons-material/Call';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import '../../../UiStyles/Animation/styles.css';
import '../../../UiStyles/CallScreen/styles.css';
import './../styles.css';
import { LoginContext } from '../../../App';
import Conference from '../../../containers/Conference';
import { useSelector } from 'react-redux';
import { Image } from '../../../libs/CustomHooks/Image';
const GroupCallReceiveScreen = (props) =>
{
	const [ participate, setParticipate ] = useState<boolean>(false);
	const { socket, call, setCall } = useContext(LoginContext);
	const [ roomDetails, setRoomDetails ] = useState<any>(null);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const callTimer = useRef<any>(null);

	const handleOpen = () =>
	{
		setParticipate(!participate);
	};

	const rejectCall = () =>
	{
		socket?.emit('reject_inc_call', { roomId: call?.roomId });
		setCall({ status: false, type: null, callBy: null, roomId: null, roomUsers: null, roomType: null });
	};

	const acceptCall = () =>
	{
		socket?.emit('accept_inc_call', { roomId: call?.roomId });
	};

	useEffect(() =>
	{
		if (call?.inapi)
		{
			clearTimeout(callTimer.current);
		}
		else if (!call?.inapi)
		{
			clearTimeout(callTimer.current);
			callTimer.current = setTimeout(() =>
			{
				rejectCall();
			}, 30000);
		}

		return () =>
		{
			clearTimeout(callTimer.current);
		};
	}, [ call ]);

	useEffect(() =>
	{
		!call?.inapi && socket?.emit('call_received', { roomId: call?.roomId });
		if (call?.custom)
		{
			setRoomDetails(call?.roomDetails[userData?.companyId]);
		}
		else
		{
			setRoomDetails(call?.roomDetails);
		}
	}, []);

	const endCallBeforeConnect = useCallback((data) =>
	{
		if (data?.roomId === call?.roomId)
		{
			setCall({ status: false, type: null, callBy: null, roomId: null });
		}
	}, [ call ]);

	const acceptIncCall = useCallback(async (data) =>
	{
		if (call?.roomId === data?.roomId)
		{
			if (data.roomType === 'group')
			{
				if (!call?.inapi)
				{
					setCall({ ...data, status: true });
				}
				else
				{
					setCall({ ...call, reason: null, roomUsers: data?.roomUsers, inapi: data?.inapi });
				}
			}
		}
	}, [ socket, call ]);

	useEffect(() =>
	{
		if (socket)
		{
			socket.on('end_call_before_connect', endCallBeforeConnect);
			socket.on('accept_inc_call', acceptIncCall);
		}

		return () =>
		{
			socket.off('end_call_before_connect');
			socket.off('accept_inc_call');
		};
	}, [ socket, call ]);

	const checkSlider = `flexCol ${!call?.inapi ? 'withoutparticipateCallSlider' : 'withoutBtnCallSlider maxHeightCallScreen callSliderIn'} `;

	return (
		<>
			{roomDetails &&
			<div className='flexRow fixedFullScreenOverlay alignCntr justifyCntr'>
				<div className={`flexCol callScreen justifyBtwn ${call?.inapi && call?.type === 'video' && 'fullCallScreen'}`}>
					{!call.inapi && <div className='flexMinWidthCol pdngTNodata'>
						<div className='flexInline pdngTLG'>
							<div className='callAnimation'>
								<Image src={roomDetails?.groupPic ? roomDetails?.groupPic : '/images/icons/defaultUser.svg'} alt='user' fallback={<img src='/images/icons/defaultUser.svg' alt='fallback'/>}/>
							</div>
						</div>
						<div className='flexCol alignCntr justifyCntr pdngTLG'>
							<h2 className='mainHdngTxt whiteTxt textCntr capitalTxt'>
								{roomDetails?.groupName}
							</h2>
							<div className='flexRow alignCntr justifyCntr pdngTSM'>
								<div className='flexInline pdngHSM'>
									<PhoneIcon className='whiteTxt' />
								</div>
								<span className='subHeadingSM whiteLightTxt textCntr'>
									{props?.label}
								</span>
							</div>
						</div>
					</div>}
					{call.inapi && <Conference token={call?.inapi.token} session={call?.inapi?.session} callType={call?.type}/>}
					<button tabIndex={0} className={participate ? 'flexRow alignCntr justifyCntr overlaySliderCallScreen fadeInOverlay' : ''} onKeyUp={(e) => e.key === 'Enter' && setParticipate(!participate)} onClick={() => { setParticipate(!participate); }}/>
					<div
						className={
							participate
								? 'flexCol participateCallSlider maxHeightCallScreen slideOut'
								: checkSlider
						}
					>
						<div className='flexCol alignCntr'>
							<div className='flexRow alignCntr justifyCntr pointer brdrBWhiteL'>
								<button
									className='flexInline '
									tabIndex={0}
									onKeyUp={(e) => e.key === 'Enter' && handleOpen()}
									onClick={handleOpen}
								>
									{participate
										? (
											<KeyboardArrowDownIcon
												fontSize='large'
												className='whiteLightTxt'
											/>
										)
										: (
											<KeyboardArrowUpIcon fontSize='large' className='whiteLightTxt' />
										)}
								</button>
							</div>
							{!call?.inapi &&

								<div className='flexRow pdngBXS justifyAround'>
									<button className='flexInline pdngSM alignCntr justifyCntr' tabIndex={0} onKeyUp={(e) => e.key === 'Enter' && rejectCall()} onClick={rejectCall}>
										<div className='flexInline callBtn endCallBtn alignCntr justifyCntr'>
											<CallEndIcon fontSize='large' className='whiteTxt' />
										</div>
									</button>
									<button className='flexInline pdngSM alignCntr justifyCntr' tabIndex={0} onKeyUp={(e) => e.key === 'Enter' && acceptCall()} onClick={acceptCall}>
										<div className='flexInline callBtn receiveBtn alignCntr justifyCntr'>
											<CallIcon fontSize='large' className='whiteTxt' />
										</div>
									</button>
								</div>

							}
							{participate && <GroupAudioCallPartipateList roomMembers={call?.roomUsers}/>}
						</div>
					</div>
					{!call.inapi && <audio id='ringer' autoPlay loop muted={call?.callStatus === 'ongoing'} >
						<source src='/audio/ringone.mp3' type='audio/mpeg' />
						<source src='/audio/ringtwo.wav' type='audio/mpeg' />
						<track src='' kind='subtitles' srcLang='en' label='English' />
					</audio>}
				</div>
			</div>
			}
		</>
	);
};

export default GroupCallReceiveScreen;
